/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGetAuth, apiPostAuth } from '../../amplify/restClient';
import { setMessage } from '../actions/message';

const initialState = {
  survey: {
    status: 'idle',
    error: null,
    result: null,
  },
  estimataCities: null,
  estimataCitiesStatus: 'idle',
  estimataCitiesError: null,
};

// eslint-disable-next-line default-param-last
export const postSurvey = createAsyncThunk('misc/postSurvey', async (body = {}, { dispatch, rejectWithValue }) => {
  try {
    const response = await apiPostAuth('myAPI', 'misc/survey', {
      body,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    dispatch(setMessage('surveySentSuccessfully'));
    return response;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || error?.toString() || 'Unknown error';
    console.error(message);
    dispatch(setMessage('surveySendingError'));
    return rejectWithValue(message);
  }
});

export const getEstimataCities = createAsyncThunk('misc/getEstimataCities', async (body, { dispatch, rejectWithValue }) => {
  try {
    const response = await apiGetAuth('myAPI', 'realestate/estimata/cities', {
      headers: {
        'Content-Type': 'application/json',
      },
    }); // returns array of arrays
    return response;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || error?.toString() || 'Unknown error';
    console.error(message);
    dispatch(setMessage('surveySendingError'));
    return rejectWithValue(message);
  }
});

const miscSlice = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    resetSurveyState(state) {
      state.survey = { ...initialState.survey };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postSurvey.pending, (state) => {
        state.survey.status = 'loading';
        state.survey.error = null;
      })
      .addCase(postSurvey.fulfilled, (state, action) => {
        state.survey.status = 'succeeded';
        state.survey.result = action.payload;
      })
      .addCase(postSurvey.rejected, (state, action) => {
        state.survey.status = 'failed';
        state.survey.error = action.payload || action.error?.message || 'Unknown error';
      })
      .addCase(getEstimataCities.pending, (state) => {
        state.estimataCitiesStatus = 'loading';
        state.estimataCitiesError = null;
      })
      .addCase(getEstimataCities.fulfilled, (state, action) => {
        state.estimataCitiesStatus = 'succeeded';
        state.estimataCities = action.payload;
      })
      .addCase(getEstimataCities.rejected, (state, action) => {
        state.estimataCitiesStatus = 'failed';
        state.estimataCitiesError = action.payload || action.error?.message || 'Unknown error';
      });
  },
});
export const { resetSurveyState } = miscSlice.actions;
export default miscSlice.reducer;
